import React, { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { QFormControl, QSelect, QSelectItem, QSelectPlaceholder, QText } from '@qualio/ui-components';

import { useQualityUsers } from '../../hooks/useQualityUsers';

export const UNASSIGNED_OWNER = 'unassigned';

const byLabel = (a: QSelectItem, b: QSelectItem) => a.label.localeCompare(b.label);

export const TemplateOwnerFilter: React.FC = () => {
  const { t } = useTranslation();
  const { data: users, isLoading } = useQualityUsers();

  const ownerOptions = useMemo<QSelectItem[]>(
    () => [
      { value: UNASSIGNED_OWNER, label: t('template.list.filters.owner.unassigned') },
      ...(users ?? []).map((user) => ({ value: String(user.user_id), label: user.full_name })).sort(byLabel),
    ],
    [users, t],
  );

  return (
    <Controller
      name="owner"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t('template.list.filters.owner.label')}>
          <QSelect
            options={ownerOptions}
            value={value ?? null}
            onChange={(item: QSelectItem | null) => onChange(item?.value ?? null)}
            isClearable
            isLoading={isLoading}
            clearInputOnSelect={value == null}
            data-cy="template-owner-filter-v2"
            aria-label={t('template.list.filters.owner.ariaLabel')}
          >
            <QSelectPlaceholder>
              <QText>{t('template.list.filters.owner.placeholder')}</QText>
            </QSelectPlaceholder>
          </QSelect>
        </QFormControl>
      )}
    />
  );
};
